export default __webpack_public_path__ + "static/media/ic_arrow_triangle_down_white.801bbfc6.svg";